import {
  Globe, Mail, Github, NotebookPen, Youtube, Figma, Calendar, MessageSquare,
  Music, Film, Camera, ShoppingCart, CreditCard, BarChart3, Code2, Terminal,
  Cloud, Database, FileText, Folder, Image, Map, Newspaper, Rss, Send,
  Slack, Twitter, Zap, Briefcase, Bookmark, Heart, Star, Rocket, Bot, Palette,
  Cpu, LayoutDashboard, Wallet, Phone, Video, Headphones, Gamepad2, Coffee,
  Building2, GraduationCap, Users, Settings,
} from "lucide-react";

export const ICONS = {
  Globe, Mail, Github, NotebookPen, Youtube, Figma, Calendar, MessageSquare,
  Music, Film, Camera, ShoppingCart, CreditCard, BarChart3, Code2, Terminal,
  Cloud, Database, FileText, Folder, Image, Map, Newspaper, Rss, Send,
  Slack, Twitter, Zap, Briefcase, Bookmark, Heart, Star, Rocket, Bot, Palette,
  Cpu, LayoutDashboard, Wallet, Phone, Video, Headphones, Gamepad2, Coffee,
  Building2, GraduationCap, Users, Settings,
};

export const ICON_NAMES = Object.keys(ICONS);

export const COLORS = [
  "bg-red-500", "bg-orange-500", "bg-amber-500", "bg-yellow-500", "bg-lime-500",
  "bg-green-500", "bg-emerald-500", "bg-teal-500", "bg-cyan-500", "bg-sky-500",
  "bg-blue-500", "bg-indigo-500", "bg-violet-500", "bg-purple-500", "bg-fuchsia-500",
  "bg-pink-500", "bg-rose-500", "bg-zinc-700",
];

export const getIcon = (name) => ICONS[name] || Globe;
